import { Button, Flow, Modal, ModalBody, ModalFooter, ModalHeader } from 'bold-ui'
import { Form, FormRenderProps } from 'components/form'
import { MSG_SUBTITULO_GERENCIAMENTO_DOCUMENTOS } from 'view/cidadao/constants-cidadao'

import { DocumentoGerenciavelFormModel, GerenciamentoDocumentosFormModel } from '../types/model-cidadao'
import { toggleDocumentoPrincipal, toggleDocumentoRemovido } from '../utils-documentos-cidadao'
import { GerenciamentoDocumentoCard } from './GerenciamentoDocumentoCard'

interface ModalGerenciamentoDocumentosProps {
  readonly isModalOpen: boolean
  readonly documentosAssociados: DocumentoGerenciavelFormModel[]
  onConfirm(documentos: DocumentoGerenciavelFormModel[]): void
  onClose(): void
}

export const ModalGerenciamentoDocumentos = ({
  isModalOpen,
  documentosAssociados,
  onConfirm,
  onClose,
}: ModalGerenciamentoDocumentosProps) => {
  const initialValues: GerenciamentoDocumentosFormModel = { documentos: documentosAssociados }

  const renderForm = ({ values, form, handleSubmit }: FormRenderProps<GerenciamentoDocumentosFormModel>) => {
    const handleTogglePrincipal = (documento: string) =>
      form.change('documentos', toggleDocumentoPrincipal(values.documentos, documento))

    const handleToggleExcluir = (documento: string) =>
      form.change('documentos', toggleDocumentoRemovido(values.documentos, documento))

    return (
      <Modal open={isModalOpen} onClose={onClose} size='small' closeOnBackdropClick={true}>
        <ModalHeader
          icon={{ name: 'infoCircleOutline', fill: 'normal' }}
          title='Gerenciar documentos'
          subtitle={MSG_SUBTITULO_GERENCIAMENTO_DOCUMENTOS}
        />
        <ModalBody>
          <Flow direction='vertical'>
            {values.documentos.map((documento) => (
              <GerenciamentoDocumentoCard
                key={documento.documento}
                documento={documento}
                onTogglePrincipal={() => handleTogglePrincipal(documento.documento)}
                onToggleExcluir={() => handleToggleExcluir(documento.documento)}
              />
            ))}
          </Flow>
        </ModalBody>
        <ModalFooter>
          <Flow direction='horizontal' justifyContent='flex-end'>
            <Button type='button' onClick={onClose}>
              Cancelar
            </Button>
            <Button type='button' kind='primary' onClick={handleSubmit}>
              Confirmar
            </Button>
          </Flow>
        </ModalFooter>
      </Modal>
    )
  }

  return (
    <Form<GerenciamentoDocumentosFormModel>
      initialValues={initialValues}
      onSubmit={({ documentos }) => onConfirm(documentos)}
      render={renderForm}
    />
  )
}
